let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jIwnn")).then(() => parcelRequire('eolux'));